export default {
  toast_messages: {
    google_review_uploaded: 'A sua avaliação foi verificada com sucesso. Ganhou {{points}} pts 😉',
  },
};
